import { IElementContainer } from "../../utils/ui/ElementContainer";
import { LeanToWraparoundSetting } from "../../config/LeanToWraparoundSetting";
import { Templating } from "../../utils/Templating";
import { BooleanInput } from "../../utils/ui/BooleanInput";

export interface ILeanToWraparoundViewConfig
{
	id?: string;
	horizontal: string; // left or right
	vertical: string;   // back or front
}

export class LeanToWraparoundView implements IElementContainer
{
	public element:HTMLElement;
	private _checkBox:HTMLInputElement;

	private _setting:LeanToWraparoundSetting;

	constructor(setting:LeanToWraparoundSetting)
	{
		this._setting = setting;
		var horizontal = setting.horizontal;
		var vertical   = setting.vertical;
		var id = vertical + "-" + horizontal;

		var config = {
			id: id,
			horizontal: horizontal,
			vertical: vertical
		};

		this.element = Templating.renderDOMFromScript("leanToWraparound", config);
		const booleanInput = new BooleanInput({id: config.id, addLabel: true, label: "Wrap:", vertical: true});
		this.element.style.position = "relative";
		this.element.appendChild(booleanInput.element);
		this._checkBox = booleanInput.input;

		this._checkBox.addEventListener("change", this.onCheckBoxChange);

		this.update();
		this._setting.allowed.signal.add(this.update);
		this._setting.enabled.signal.add(this.update);
		this._setting.notAllowedReason.signal.add(this.update);
	}

	private onCheckBoxChange = (event:Event) =>
	{
		if (this._setting.allowed.value)
		{
			var checked = this._checkBox.checked;

			this._setting.enabled.setValue(checked);
		}
		else
		{
			// pointer-events is set to none, but still make sure it's not checked by user
			this._checkBox.checked = false;
		}
	};

	// TODO: this probably runs a bit too often, could be optimized
	private update = () =>
	{
		var allowed = this._setting.allowed.value;

		if (allowed)
		{
			this.element.classList.remove("disabled");
		}
		else
		{
			this.element.classList.add("disabled");
		}

		this.element.title = this._setting.notAllowedReason.value;

		// This is needed when enabled is changed by not the user:
		// - when matching conditions got broken so enabled was force-set to false
		// - when a project is loaded
		this._checkBox.checked = this._setting.enabled.value;
	};
}
